
const reasons = [
  {
    icon: 'ri-time-fill',
    title: '24/7 Emergency Response',
    description: 'Downtime costs money. Our mobile welding crews are available around the clock for emergency repairs — on your job site, when you need us most.',
  },
  {
    icon: 'ri-money-dollar-circle-fill',
    title: 'Competitive Contractor Pricing',
    description: 'Transparent, competitive pricing with no hidden fees. We work within your project budget and deliver exceptional value on every weld.',
  },
  {
    icon: 'ri-award-fill',
    title: 'Experienced & Certified',
    description: 'Our welders bring years of hands-on experience across structural steel, heavy equipment, and custom fabrication — delivering code-compliant results every time.',
  },
  {
    icon: 'ri-truck-fill',
    title: 'Mobile & On-Site Service',
    description: 'We bring the shop to you. Fully equipped mobile welding rigs serve job sites across Northern California and Southern California.',
  },
  {
    icon: 'ri-shield-check-fill',
    title: 'Licensed & Fully Insured',
    description: 'Work with confidence. New Generation Welding is fully licensed and insured, meeting all contractor requirements for commercial and industrial projects.',
  },
  {
    icon: 'ri-user-star-fill',
    title: 'Contractor-Focused Service',
    description: 'We understand contractor timelines. Fast turnaround, clear communication, and reliable execution — so your project stays on track.',
  },
];

export default function WhyChooseUs() {
  return (
    <section id="why-choose-us" className="py-24 bg-[#F8F7F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-10 h-0.5 bg-[#E8740C]"></div>
            <span className="text-[#E8740C] text-xs font-semibold tracking-[0.2em] font-heading uppercase">Why Contractors Choose Us</span>
            <div className="w-10 h-0.5 bg-[#E8740C]"></div>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-tight mb-4">
            BUILT FOR <span className="text-[#E8740C]">CONTRACTORS</span>
          </h2>
          <p className="text-[#4A4A4A] text-sm max-w-2xl mx-auto leading-relaxed font-body">
            General contractors, builders, and project managers choose New Generation Welding for reliable, on-time welding and fabrication services that meet the demands of commercial and industrial construction.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason) => (
            <article key={reason.title} className="bg-white rounded-lg p-7 shadow-sm hover:shadow-md transition-shadow duration-300 border border-[#E8E6E2]">
              <div className="w-12 h-12 flex items-center justify-center bg-[#E8740C]/10 rounded-lg mb-5">
                <i className={`${reason.icon} text-[#E8740C] text-xl`}></i>
              </div>
              <h4 className="font-heading font-bold text-[#1A1A1A] text-base mb-3">
                <a href="#request-quote" className="hover:text-[#E8740C] transition-colors cursor-pointer">{reason.title}</a>
              </h4>
              <p className="text-[#6A6A6A] text-xs leading-relaxed font-body">{reason.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
